<template>
  <b-overlay
    ref="overlay_index"
    variant="white"
    :show="showLoading"
    spinner-variant="primary"
    blur="0"
    opacity=".75"
    rounded="sm"
  >
    <b-card>
      <div>
        <!-- Botón Atrás -->
        <b-row class="mb-3">
          <b-col>
            <b-button variant="secondary" @click="$router.go(-1)">
              <feather-icon icon="ArrowLeftIcon" class="mr-2" /> Atrás
            </b-button>
          </b-col>
        </b-row>

        <b-row>
          <!-- Tienda Origen -->
          <b-col sm="6" md="4" lg="3">
            <b-form-group label="Tienda Origen">
              <v-select
                :options="locals"
                label="name"
                v-model="form.storeOrigin"
                :reduce="(option) => option.id"
                placeholder="Seleccione Tienda Origen"
                @input="handleStoreOriginChange"
              />
            </b-form-group>
          </b-col>

          <!-- Tienda Destino -->
          <b-col sm="6" md="4" lg="3">
            <b-form-group label="Tienda Destino">
              <v-select
                :options="localsDestination"
                label="name"
                v-model="form.storeDestination"
                :reduce="(option) => option.id"
                placeholder="Seleccione Tienda Destino"
              />
            </b-form-group>
          </b-col>

          <!-- Descripción -->
          <b-col sm="6" md="4" lg="3">
            <b-form-group label="Descripción">
              <b-form-input
                v-model="form.description"
                placeholder="Descripción del Movimiento"
              />
            </b-form-group>
          </b-col>

          <!-- Documento -->
          <b-col sm="6" md="4" lg="3">
            <b-form-group label="Documento">
              <b-form-input
                v-model="form.document"
                placeholder="N° de Documento"
              />
            </b-form-group>
          </b-col>

          <!-- Autoparte -->
          <b-col md="12">
            <b-form-group label="Autoparte">
              <v-select
                :options="autoparts"
                label="label"
                v-model="newItem.description"
                placeholder="Seleccione una Autoparte"
                :reduce="(autopart) => autopart"
                :filterable="true"
                :filter-by="customFilter"
                @input="updateQtyAvailable"
              />
            </b-form-group>
          </b-col>

          <!-- Cantidad Disponible -->
          <b-col sm="6" md="4" lg="2">
            <b-form-group label="Cantidad Disponible">
              <b-form-input
                type="number"
                v-model="newItem.qtyAvailable"
                readonly
              />
            </b-form-group>
          </b-col>

          <!-- Cantidad Requerida -->
          <b-col sm="6" md="4" lg="2">
            <b-form-group label="Cantidad Requerida">
              <b-form-input
                type="number"
                v-model="newItem.requiredQty"
                @input="limitStockInput"
                placeholder="Ingrese Cantidad Requerida"
              />
            </b-form-group>
          </b-col>

          <!-- Botón Agregar -->
          <b-col sm="5" md="2" class="d-flex align-items-center mt-1">
            <b-button variant="primary" @click="addRow">Agregar</b-button>
          </b-col>
        </b-row>

        <!-- Tabla para las Autopartes -->
        <b-card no-body class="mb-3">
          <b-table
            :items="tableItems"
            :fields="fields"
            responsive
            hover
            class="mt-3"
          >
            <!-- Celda de Cantidad -->
            <template #cell(requiredQty)="data">
              <b-form-input
                v-model="data.item.requiredQty"
                type="number"
                @input="limitStock(data.item)"
              />
            </template>

            <!-- Botón de Eliminar -->
            <template #cell(actions)="data">
              <b-button
                size="sm"
                variant="danger"
                @click="removeRow(data.index)"
              >
                Eliminar
              </b-button>
            </template>
          </b-table>
        </b-card>

        <!-- Botón para Actualizar -->
        <b-button variant="success" @click="updateMovement"
          >Actualizar</b-button
        >
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import InternalMovement from "@/services/InternalMovement";
import InventoryService from "@/services/InventoryService";
import StoreService from "@/services/StoresService";
import AutoPartsService from "@/services/AutoParts";
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    vSelect,
  },
  data() {
    return {
      showLoading: false,
      autopartBrands: [],
      form: {
        storeOrigin: null,
        storeDestination: null,
        description: "",
        document: "",
      },
      newItem: {
        description: null,
        qtyAvailable: null,
        requiredQty: null,
      },
      tableItems: [],
      fields: [
        { key: "description.autopart.uniqueCode", label: "Código Único", sortable: true },
        { key: "description.brandName", label: "Marca" },
        { key: "description.autopart.originalCode", label: "Cod. Original" },
        {
          key: "description.autopart.alterCode",
          label: "Código Alterno",
          sortable: false,
        },
        { key: "description.autopart.description", label: "Descripción" },
        { key: "requiredQty", label: "Cantidad Requerida" },
        { key: "actions", label: "Acciones" },
      ],
      locals: [],
      localsDestination: [],
      autoparts: [],
      storeOrigin: null,
    };
  },
  mounted() {
    const movementId = this.$route.params.id;
    if (movementId) {
      this.loadMovementForEdit(movementId);
    }
    this.getData();
    this.getLocals();
  },
  methods: {
    async handleStoreOriginChange(newStoreOrigin) {
      if (this.storeOrigin !== newStoreOrigin) {
        this.tableItems = [];
        this.storeOrigin = newStoreOrigin;

        await this.loadAutoparts();
      }
    },

    async getData() {
      this.localsDestination = [];
      let datosUser = JSON.parse(localStorage.getItem("userData"));
      if (datosUser && datosUser.data && datosUser.data.userEstablishments) {
        datosUser.data.userEstablishments.forEach((element) => {
          this.localsDestination.push({
            id: element.id,
            name: element.name,
          });
        });
        this.form.storeDestination = datosUser.data.establishmentDefault;
      }
    },

    async getLocals() {
      this.locals = [];
      const resp = await StoreService.getStores("", this.$store);
      if (resp.data.rows.length != 0) {
        this.locals = resp.data.rows;
      }
    },

    customFilter(option, label, search) {
      if (!search) return true;
      const normalizedLabel = label.toLowerCase();
      const normalizedSearch = search.toLowerCase().split(" ");
      return normalizedSearch.every((word) => normalizedLabel.includes(word));
    },

    async loadMovementForEdit(id) {
      try {
        this.showLoading = true;
        const response = await InternalMovement.getMovInternal(id, this.$store);
        const { internalMovement, internalDetail } = response.data;

        this.form.storeOrigin = internalMovement.establishmentOriginId;
        this.form.storeDestination = internalMovement.establishmentDestinyId;
        this.form.description = internalMovement.description;
        this.form.document = internalMovement.documentCode;
        this.storeOrigin = internalMovement.establishmentOriginId;

        await this.loadAutoparts();

        this.tableItems = internalDetail.map((item) => {
          console.log("Item a EDITAR:", item);
          const brand = this.autopartBrands.find((b) => b.id === item.autopart.autopartBrandId);
          const brandName = brand ? brand.name : 'Sin Marca';

          return {
            description: {
              autopart: item.autopart,
              uniqueCode: item.autopart.uniqueCode,
              label: `${item.autopart.uniqueCode} - ${item.autopart.description}`,
              qtyAvailable: item.qtyAvailable || 0,
              brandName: brandName,
            },
            requiredQty: item.qty,
          };
        });
      } catch (error) {
        console.error("Error al cargar datos para editar:", error);
      } finally {
        this.showLoading = false;
      }
    },

    limitStock(item) {
      if (item.requiredQty > item.qtyAvailable) {
        item.requiredQty = item.qtyAvailable;
      }
    },
    async loadAutoparts() {
      if (!this.form.storeOrigin) return;
      const resp = await InventoryService.getStockxStore(
        this.form.storeOrigin,
        this.$store
      );
      if (resp.data.length !== 0) {
        this.autoparts = resp.data.map((item) => ({
          label: `${item.autopart.AutopartBrand.name} - ${item.autopart.originalCode}  - ${item.autopart.description}`,
          autopart: item.autopart,
          qtyAvailable: item.qtyAvailable,
        }));
      } else {
        this.autoparts = [];
      }
    },
    updateQtyAvailable() {
      if (this.newItem.description) {
        this.newItem.qtyAvailable = this.newItem.description.qtyAvailable;
      }
    },
    limitStockInput() {
      if (this.newItem.requiredQty > this.newItem.qtyAvailable) {
        this.newItem.requiredQty = this.newItem.qtyAvailable;
      }
    },
    limitStock(item) {
      if (item.requiredQty > item.qtyAvailable) {
        item.requiredQty = item.qtyAvailable;
      }
    },
    addRow() {
      if (!this.newItem.description || !this.newItem.requiredQty) {
        this.$swal("Error", "Todos los campos son obligatorios", "error");
        return;
      }

      const isDuplicate = this.tableItems.some(
        (item) =>
          item.description.autopart.id === this.newItem.description.autopart.id
      );

      if (isDuplicate) {
        this.$swal("Error", "La autoparte ya está en la lista", "error");
        return;
      }

      const autopart = this.newItem.description.autopart;
const brandName = autopart.AutopartBrand?.name || 'Sin Marca';

this.tableItems.push({
  description: {
    autopart: autopart,
    label: this.newItem.description.label,
    qtyAvailable: this.newItem.qtyAvailable,
    brandName: brandName,
  },
  requiredQty: this.newItem.requiredQty,
});

      this.newItem = {
        description: null,
        qtyAvailable: null,
        requiredQty: null,
      };
    },

    removeRow(index) {
      this.tableItems.splice(index, 1);
    },
    async updateMovement() {
      try {
        const autoparts = this.tableItems.map((item) => ({
          autopartId: item.description.autopart.id,
          qty: parseInt(item.requiredQty, 10),
        }));

        const data = {
          establishmentOriginId: this.form.storeOrigin,
          establishmentDestinyId: this.form.storeDestination,
          description: this.form.description,
          documentCode: this.form.document,
          state: "Modificado",
          autoparts,
        };

        console.log("Datos a enviar:", data);

        const response = await InternalMovement.updateMovements(
          this.$route.params.id,
          data,
          this.$store
        );

        if (response) {
          this.$swal({
            title: "Actualizado",
            text: "El movimiento fue actualizado exitosamente.",
            icon: "success",
          });
          this.$router.push("/inventario/entrada/historial/");
        }
      } catch (error) {
        console.error("Error al actualizar movimiento:", error);
        this.$swal("Error", "Ocurrió un error al actualizar.", "error");
      }
    },
  },
};
</script>

<style></style>
